import type { FaireProductEntity } from "../../entity_types/product";

export const p_nfb8dd5m29: FaireProductEntity = {
  token: "p_nfb8dd5m29",
  type: "product",
  name: "3/4 Sleeve Boxy Knit Button Down Sweater Cardigan (S-XL)",
  brandToken: "b_fpqcwkn7v8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ccfe688206f73f583f2c3a7733125d83893e6f60a9292eaab936672e3212d694.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e830b66befb869eca0af91ba24b4a1406a259b041b278c198a7832a3392e74b8.jpeg",
    "https://cdn.faire.com/fastly/c3207f5309e44c5b1ab6066b61a5770ccb4bdef54e1c31f4ec5eca32af93b446.png",
    "https://cdn.faire.com/fastly/c779aebb73e5d9afaf0a374346a1c386d5d7a4bae54f45e8a346011f8f900021.jpeg",
    "https://cdn.faire.com/fastly/d5435ec4b2b9e4a023f88d0181ed330bb206e53ee06da3143189ecff52cf9d1f.jpeg",
    "https://cdn.faire.com/fastly/fbf05307ba06193b04bdf8a1d91f7726c2081040a15dafc5eb9392c7807d1370.jpeg",
    "https://cdn.faire.com/fastly/6dae8a99167c3004eda36b6e799ebfce6b3ffce8a81d4a51d773e6474645b72a.jpeg",
    "https://cdn.faire.com/fastly/9beb4004f39fbb08ff5a18ae6fd62457eea90403e4d639e85efe93b7172e7efd.jpeg",
    "https://cdn.faire.com/fastly/6b00e3f6919fb8c0f4b3714340ccc19b6b29ac98f68845af735767220bf5aead.jpeg",
    "https://cdn.faire.com/fastly/2019d5d2b540b5f90b15f852a3e4e2b59beae51726a2bb2fcfc605e0b647bcca.jpeg",
    "https://cdn.faire.com/fastly/dee84913e0815660932777e7920c0ffe58d68cc233b176659ab2efb6ef992be7.jpeg",
    "https://cdn.faire.com/fastly/136f9f8b6d66a94b936a9e8be6307b3367e12132bd7dac0f3e90c682c4f48159.jpeg",
    "https://cdn.faire.com/fastly/f942845891e2b7daf5bcc0f132d9ce358bd17942b3d12da17a165925d18e5a9b.jpeg",
    "https://cdn.faire.com/fastly/bd2a18313acbede43f8c41934405a5518a26e0d373a57cbc93c4acc4ac87dd83.jpeg",
    "https://cdn.faire.com/fastly/1d41c5dcad4470ceff83ab5f836c28f7f9f8891b9849145324f11bb8aad4d29e.jpeg",
    "https://cdn.faire.com/fastly/0b3781a4a640076d6a8d03da1df9f088c62eda12332f3d185aef87f7d2b0a4a0.jpeg",
  ],
  priceDollars: 24.18,
  description:
    "🎀Material: 42%Acrylic+30%Polyester+28%Polyamide\n😍Why You’ll Love It?\n\nModern boxy silhouette creates a trendy, relaxed fit\nVersatile 3/4 sleeves offer a clean, transitional look\nClassic button-down front allows for easy layering and styling\nTextured knit fabric provides a cozy yet polished feel\n\n💌Note: Our products currently come with size and care labels only. If you need branded labels, please contact us for custom options!",
  tags: [],
  msrpDollars: 48.36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:09.355Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
